<script>
const GUIDES = {
  home: {
    heading: '내 상품 현황에서 하는 일',
    description: '현재 취급 중인 상품 구성과 등록·연결 요청을 분리하여 확인합니다.',
    cards: [
      { icon: 'inventory_2', title: '취급 상품 현황', copy: '기준 상품과 연결된 내 SKU의 전체 수와 사용 가능 여부를 확인합니다.' },
      { icon: 'sell', title: '상품 구성', copy: '내가 취급하는 브랜드와 카테고리별 상품 분포를 확인합니다.' },
      { icon: 'fact_check', title: '등록·연결 요청', copy: '운영팀 검토 중이거나 반려되어 보완이 필요한 요청을 확인합니다.' },
    ],
    steps: [
      { title: '상단 취급 상품 현황을 확인합니다.', copy: '전체 취급 상품, 사용 가능, 사용 중지, 브랜드, 카테고리 수를 먼저 확인하세요.' },
      { title: '브랜드와 카테고리 분포를 확인합니다.', copy: '취급 상품 수가 많은 상위 브랜드와 카테고리를 비교할 수 있습니다.' },
      { title: '최근 취급 상품을 확인합니다.', copy: '상품 행을 누르면 내 상품 상세 화면에서 연결된 기준 상품 정보를 볼 수 있습니다.' },
      { title: '등록·연결 요청 현황을 확인합니다.', copy: '검토 중과 반려 요청은 취급 상품과 구분하여 보조 영역에서 확인하세요.' },
      { title: '새 상품은 상품 요청 등록으로 진행합니다.', copy: '타이틀 우측 상품 요청 등록 버튼을 누르세요.' },
    ],
    note: '검토 중이거나 반려된 요청은 취급 상품 수에 포함되지 않습니다. 운영팀 연결 처리가 완료된 내 SKU만 취급 상품으로 집계됩니다.'
  },
  productList: {
    heading: '내 상품목록 관리에서 하는 일',
    description: '내가 등록했거나 요청한 상품을 검색하고 처리 상태를 확인합니다.',
    cards: [
      { icon: 'filter_alt', title: '상태 검색', copy: '검토 중, 정상 연결, 반려 상태를 구분해 확인합니다.' },
      { icon: 'sell', title: '브랜드·카테고리 검색', copy: '내가 취급하는 브랜드와 카테고리 기준으로 상품을 찾습니다.' },
      { icon: 'add_circle', title: '상품 요청 등록', copy: '새로운 내 SKU를 운영팀에 등록 요청합니다.' },
    ],
    steps: [
      { title: '상단 상태 요약을 확인합니다.', copy: '검토 중, 반려, 정상 연결 건수를 기준으로 현재 작업 상태를 파악하세요.' },
      { title: '검색 조건을 선택합니다.', copy: '상태, 브랜드, 카테고리 또는 내 SKU 검색어를 조합할 수 있습니다.' },
      { title: '목록에서 요청 유형과 처리 상태를 확인합니다.', copy: '연결요청인지 신규등록요청인지, 운영팀 처리가 완료되었는지 확인하세요.' },
      { title: '행 또는 상세보기 아이콘을 누릅니다.', copy: '내 SKU의 기준 상품 정보, 규격 상세, 반려 사유를 확인할 수 있습니다.' },
      { title: '반려 건은 내용을 보완합니다.', copy: '반려된 요청은 운영팀 안내를 확인하고 상품 요청 등록을 다시 진행하세요.' },
      { title: '새 상품은 상품 요청 등록 버튼을 누릅니다.', copy: '입력 팝업에서 내 SKU와 상품 조건을 입력합니다.' },
    ],
    note: '목록에 보이는 브랜드와 카테고리 필터는 내가 등록했거나 요청한 상품에서 사용하는 항목만 표시됩니다.',
    glossaryTitle: '처리 상태',
    glossary: [
      { term: '검토 중', description: '운영팀이 요청 내용을 확인하고 있습니다.' },
      { term: '정상 연결', description: '내 SKU가 기준 상품과 연결되었습니다.' },
      { term: '반려', description: '정보 보완 후 다시 요청해야 합니다.' },
      { term: '내 SKU', description: '파트너사가 자체적으로 사용하는 상품 코드입니다.' },
    ]
  },
  productDetail: {
    heading: '내 상품 상세에서 하는 일',
    description: '내 SKU가 기준 상품과 연결되었는지 확인하고 운영팀 처리 결과를 조회합니다.',
    cards: [
      { icon: 'inventory_2', title: '상품 정보', copy: '브랜드, 카테고리, HS CODE와 기준 상품 코드를 확인합니다.' },
      { icon: 'straighten', title: '규격 상세', copy: '등록 요청한 상품의 규격 타입과 상세 값을 확인합니다.' },
      { icon: 'fact_check', title: '처리 결과', copy: '정상 연결, 검토 중, 반려 상태와 반려 사유를 확인합니다.' },
    ],
    steps: [
      { title: '상단의 내 SKU를 확인합니다.', copy: '선택한 파트너 상품 코드가 맞는지 먼저 확인하세요.' },
      { title: '처리 상태와 요청 유형을 확인합니다.', copy: '정상 연결인지, 신규등록요청 또는 연결요청 검토 중인지 구분할 수 있습니다.' },
      { title: '상품 정보와 규격 상세를 확인합니다.', copy: '정상 연결된 상품은 기준 상품 코드도 함께 표시됩니다.' },
      { title: '반려 건은 사유를 확인합니다.', copy: '반려 사유를 기준으로 내용을 보완한 뒤 다시 요청하세요.' },
      { title: '목록으로 버튼으로 돌아갑니다.', copy: '이전 목록의 검색 조건을 유지한 상태로 이동합니다.' },
    ],
    note: '내 상품 상세는 조회 전용 화면입니다. 상품 연결 변경이 필요하면 운영팀에 문의하세요.'
  },
  requestNew: {
    heading: 'SKU 요청 생성에서 하는 일',
    description: '새로운 내 SKU의 상품 정보를 입력하고 운영팀에 등록 또는 연결을 요청합니다.',
    cards: [
      { icon: 'edit_note', title: '상품 정보 입력', copy: '내 SKU, 브랜드, 카테고리, HS CODE와 규격 정보를 입력합니다.' },
      { icon: 'manage_search', title: '동일 SKU 조회', copy: '입력 조건과 같은 기준 상품이 이미 있는지 확인합니다.' },
      { icon: 'send', title: '요청 제출', copy: '같은 상품이 있으면 연결요청, 없으면 신규등록요청으로 제출됩니다.' },
    ],
    steps: [
      { title: '내 SKU 코드를 입력합니다.', copy: '파트너사에서 사용하는 상품 코드를 입력하세요.' },
      { title: '브랜드와 카테고리를 선택합니다.', copy: '목록에 없다면 직접입력 토글을 켜고 이름을 입력할 수 있습니다.' },
      { title: 'HS CODE와 규격 정보를 입력합니다.', copy: 'HS CODE는 6자리 숫자입니다. 규격 타입에 맞는 상세 값도 입력하세요.' },
      { title: '동일 SKU 조회를 실행합니다.', copy: '브랜드, 카테고리, HS CODE, 규격 조건이 같은 기준 상품이 있는지 확인합니다.' },
      { title: '요청 제출을 누릅니다.', copy: '동일 조건 상품이 있으면 확인 팝업에서 연결 요청 제출을 진행합니다.' },
    ],
    note: '동일 SKU가 있어도 요청할 수 있습니다. 이 경우 새 상품 생성이 아니라 기존 기준 상품과 연결하는 요청으로 처리됩니다.',
    glossaryTitle: '동일 SKU 판단 기준',
    glossary: [
      { term: '브랜드', description: '선택하거나 직접 입력한 브랜드명' },
      { term: '카테고리', description: '선택하거나 직접 입력한 카테고리명' },
      { term: 'HS CODE', description: '6자리 숫자로 입력한 HS CODE' },
      { term: '규격', description: '규격 타입과 규격 상세 값' },
    ]
  }
}

export default {
  name: 'PartnerFulfillmentGuide',
  props: {
    guideKey: {
      type: String,
      required: true
    }
  },
  computed: {
    guide() {
      return GUIDES[this.guideKey] || GUIDES.home
    }
  }
}
</script>

<template>
  <div>
    <div class="guide-heading">{{ guide.heading }}</div>
    <p class="guide-copy">{{ guide.description }}</p>

    <div class="row q-col-gutter-md q-mt-sm">
      <div v-for="card in guide.cards" :key="card.title" class="col-12 col-md-4">
        <div class="guide-card">
          <q-icon :name="card.icon" color="primary" size="24px" />
          <div class="guide-card__title">{{ card.title }}</div>
          <div class="guide-card__copy">{{ card.copy }}</div>
        </div>
      </div>
    </div>

    <div class="guide-subheading">사용 순서</div>
    <ol class="guide-steps">
      <li v-for="(step, index) in guide.steps" :key="step.title">
        <span>{{ index + 1 }}</span>
        <div>
          <b>{{ step.title }}</b>
          <small>{{ step.copy }}</small>
        </div>
      </li>
    </ol>

    <template v-if="guide.glossary">
      <div class="guide-subheading">{{ guide.glossaryTitle }}</div>
      <div class="glossary-grid">
        <div v-for="item in guide.glossary" :key="item.term" class="glossary-item">
          <b>{{ item.term }}</b>
          <span>{{ item.description }}</span>
        </div>
      </div>
    </template>

    <q-banner rounded class="guide-warning q-mt-md">
      <template #avatar>
        <q-icon name="info" color="orange-8" />
      </template>
      {{ guide.note }}
    </q-banner>
  </div>
</template>

<style scoped>
.guide-heading {
  color: #183b56;
  font-size: 20px;
  font-weight: 700;
}

.guide-copy {
  margin: 8px 0 0;
  color: #607171;
}

.guide-card {
  height: 100%;
  padding: 16px;
  border: 1px solid #d8e1df;
  border-radius: 12px;
  background: #fff;
}

.guide-card__title,
.guide-subheading {
  color: #183b56;
  font-weight: 700;
}

.guide-card__title {
  margin-top: 10px;
}

.guide-card__copy,
.guide-steps small,
.glossary-item span {
  color: #607171;
  font-size: 13px;
}

.guide-subheading {
  margin-top: 24px;
  font-size: 16px;
}

.guide-steps {
  display: grid;
  gap: 14px;
  margin: 14px 0 0;
  padding: 0;
  list-style: none;
}

.guide-steps li {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.guide-steps li > span {
  display: inline-flex;
  width: 28px;
  height: 28px;
  flex: 0 0 28px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #fff;
  background: #1976d2;
  font-size: 12px;
  font-weight: 700;
}

.guide-steps b,
.guide-steps small,
.glossary-item b,
.glossary-item span {
  display: block;
}

.glossary-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin-top: 12px;
}

.glossary-item {
  padding: 12px;
  border: 1px solid #d8e1df;
  border-radius: 10px;
  background: #f8fafc;
}

.glossary-item b {
  color: #183b56;
}

.guide-warning {
  color: #8b581d;
  background: #fff8e8;
}

@media (max-width: 600px) {
  .glossary-grid {
    grid-template-columns: 1fr;
  }
}
</style>
